/**
 * Polyfills for ES6
 * If you need to are more polyfills see: https://github.com/zloirock/core-js
 */
require('core-js/es/map');
require('core-js/es/set');
require('core-js/es/object/assign');
require('core-js/es/promise');
require('core-js/es/symbol');
require('core-js/es/object/get-own-property-descriptor');
require('core-js/es/array/from');
require('core-js/es/array/find');
require('core-js/es/array/includes');
require('core-js/es/object/entries');
require('core-js/proposals/object-values-entries');
require('core-js/es/function');
require('core-js/es/function/bind');
require('core-js/es/object/keys');
require('core-js/es/object/create');
require('core-js/proposals/object-getownpropertydescriptors');
require('core-js/es/object/define-property');
require('core-js/es/object/define-properties');
require('core-js/es/object/values');
require('core-js/es/object');
require('core-js/es/object/set-prototype-of');
require('core-js/es/object/get-prototype-of');
require('core-js/es/object/get-own-property-names');
require('core-js/es/object/define-getter');
require('core-js/es/object/define-setter');
require('core-js/stable/dom-collections/iterator');
require('core-js/stable/dom-collections/for-each');
